var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-head"
  }, [_c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('div', {
    staticClass: "sub-visual",
    class: {
      'sub-visual--sub-tab': !_vm.subTabNone
    }
  }, [_c('div', {
    staticClass: "sub-visual__inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "sub-visual__tit-wrap"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "sub-visual__tit"
  }, [_vm._v(_vm._s(_vm.sh))])]), _vm.text ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "client-title--sm font-weight-medium white--text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e()], 1)], 1)])], 1), _c('div', {
    staticClass: "sub-visual__bg",
    style: 'background-image:url(' + _vm.bg + ');'
  })])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": _vm.mobile,
      "alt": ""
    }
  }), !_vm.subTabNone ? _c('div', {
    staticClass: "sub-head__bottom"
  }, [_c('v-container', [_c('client-gnb', {
    attrs: {
      "className": "sub-tab-wrap",
      "tabActive": _vm.tabActive,
      "sh": _vm.sh
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }